import VueAnalytics from 'vue-analytics';
import Vue from 'vue';
import App from './app.vue';
import router from './router';


Vue.config.devtools = true;
Vue.config.productionTip = true;


const originalUrl = window.location.origin;

if (originalUrl.includes('www.uk.vr-capital.com') || originalUrl.includes('www.uk.vr-capital.org')) {
  // Configuration VueAnalytics
  Vue.use(VueAnalytics, {
    id: 'UA-187813380-1',
    router,
  });
} else if (originalUrl.includes('www.sg.vr-capital.com') || originalUrl.includes('www.sg.vr-capital.org')) {
  // Configuration VueAnalytics
  Vue.use(VueAnalytics, {
    id: 'UA-187813380-3',
    router,
  });
} else if (originalUrl.includes('www.us.vr-capital.com') || originalUrl.includes('www.us.vr-capital.org')) {
  Vue.use(VueAnalytics, {
    id: 'UA-187813380-2',
    router,
  });
}


new Vue({
  router,
  render: h => h(App),
}).$mount('.app');
